import { useState } from 'react';
import { LayoutChangeEvent, View } from 'react-native';
import useAppNavigation from '_navigator/hooks/useAppNavigation';
import { WW } from '_utils';
import useImageAspectRatio from '_utils/hooks/useImageAspectRatio';
import { screenMargin, smallestMargin, smallestMarginPixels } from '_utils/sizes';
import { CacheImage } from 'Components';
import TouchableHeime from 'Components/TouchableHeime';
import { NoticeMessage } from 'types/message';
import { ArrayElement, UnixTimeCode } from 'types/Utility';

type ImageType = ArrayElement<NoticeMessage['files']>;

interface ImageGridDisplayProps {
    images: Array<ImageType & { last_modified: UnixTimeCode }>;
}

const ImageGridDisplay = ({ images }: ImageGridDisplayProps) => {
    const { navigate } = useAppNavigation();
    const [width, setWidth] = useState<number | null>(null);
    const { aspectRatio, handleLoad } = useImageAspectRatio(
        images[0] && 'blurhash' in images[0] ? (images[0].blurhash ?? null) : null,
    );

    if (images.length === 0) {
        return null;
    }

    const handleLayout = (event: LayoutChangeEvent) => {
        setWidth(event.nativeEvent.layout.width);
    };

    return (
        <View onLayout={handleLayout} style={{ marginTop: smallestMargin }}>
            <TouchableHeime
                onPress={() => {
                    navigate('ImagePreview', {
                        images,
                        selectedIndex: 0,
                    });
                }}
            >
                <CacheImage<ImageType>
                    source={images[0]}
                    style={{
                        width: '100%',
                        aspectRatio: aspectRatio || 1,
                    }}
                    resizeMode="contain"
                    onLoad={handleLoad}
                />
            </TouchableHeime>
            {images.length > 1 && (
                <View style={{ flexDirection: 'row', flexWrap: 'wrap', marginTop: smallestMargin }}>
                    {images.slice(1).map((image, index) => (
                        <TouchableHeime
                            key={image.id}
                            style={{
                                width: ((width ?? WW - screenMargin * 2) - smallestMarginPixels * 3) / 4,
                                aspectRatio: 1,
                                marginRight: (index + 1) % 4 === 0 ? 0 : smallestMargin,
                                marginBottom: smallestMargin,
                            }}
                            onPress={() => {
                                navigate('ImagePreview', {
                                    images,
                                    selectedIndex: index + 1,
                                });
                            }}
                        >
                            <CacheImage<ImageType>
                                source={image}
                                style={{ width: '100%', height: '100%' }}
                                resizeMode="cover"
                            />
                        </TouchableHeime>
                    ))}
                </View>
            )}
        </View>
    );
};

export default ImageGridDisplay;
